import { render, staticRenderFns } from "./AreaTable.vue?vue&type=template&id=50d766e1&scoped=true"
import script from "./AreaTable.vue?vue&type=script&lang=js"
export * from "./AreaTable.vue?vue&type=script&lang=js"
import style0 from "./AreaTable.vue?vue&type=style&index=0&id=50d766e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d766e1",
  null
  
)

export default component.exports